module.exports = __webpack_public_path__ + "img/servicios-mobile.b4ecb112.png";